<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Type of Misconduct Revision"
      text="Edit Type of Misconduct Revision"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="localTypeOfMisconductRevision.version"
                label="Version"
                filled
                disabled
              />
            </v-col>

            <v-col
              cols="12"
            >
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDateDisplay"
                    v-validate="'required'"
                    :error-messages="errors.collect('startDateDisplay')"
                    data-vv-name="startDateDisplay"
                    data-vv-as="start date"
                    label="Start date"
                    outlined
                    readonly
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localTypeOfMisconductRevision.start_date"
                  no-title
                  :max="localTypeOfMisconductRevision.end_date"
                  @input="startDateMenu = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="12"
            >
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="endDateDisplay"
                    label="End date"
                    outlined
                    readonly
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localTypeOfMisconductRevision.end_date"
                  no-title
                  :min="localTypeOfMisconductRevision.start_date"
                  @input="endDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10" 
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"         
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      typeOfMisconductRevision: {
        type: Object,
        default: null,
      },  
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localTypeOfMisconductRevision: null,
        startDateMenu: false,
        endDateMenu: false,
      }
    },
    computed: {
      startDateDisplay () {
        return this.localTypeOfMisconductRevision.start_date ? this.$moment(this.localTypeOfMisconductRevision.start_date, 'YYYY-MM-DD').format('DD MMM YYYY') : ''
      },
      endDateDisplay () {
        return this.localTypeOfMisconductRevision.end_date ? this.$moment(this.localTypeOfMisconductRevision.end_date, 'YYYY-MM-DD').format('DD MMM YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.localTypeOfMisconductRevision = { ...this.typeOfMisconductRevision }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.typeOfMisconductRevisions().update(this.typeOfMisconductRevision.id, this.prepareFormData())
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          version: this.localTypeOfMisconductRevision.version, 
          start_date: this.localTypeOfMisconductRevision.start_date,
          end_date: this.localTypeOfMisconductRevision.end_date,
        }   
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:1px
}
</style>
